const urlParams = new URLSearchParams(window.location.search);
const ccSendMoneyEl = document.querySelector('.container-cc-updated');
const receiverCurrencyEL = ccSendMoneyEl?.querySelector('#default-receiver-currency')
let receiverCountry = urlParams.get('ReceiverCountry')  || CookieService.getCookie('ReceiverCountry') === 'true' || receiverCurrencyEL?.getAttribute('data-default-receiver-country')?.toUpperCase();

const showCCSendMoneyConfigure = (data) => {
  receiverCountry = receiverCountry || data.receiverCountry;
  const enableRodeoExpernce = CookieService.getCookie('homePageExperience') === 'rodeo' || urlParams.get('enableRodeoExperience') === 'true';
  if(!ccSendMoneyEl || !receiverCountry || !enableRodeoExpernce) return;
  receiverCountry = receiverCountry.toUpperCase();
  const currencyConverterMain = document.querySelector('.currency-converter-main');
  const joinNowEl = document.querySelector('.join-now-main')
  if (receiverCountry && ccSendMoneyEl) {
    ccSendMoneyEl.classList.remove('d-none');
    currencyConverterMain && currencyConverterMain.remove();
    joinNowEl && joinNowEl.remove();
    const receiverFlag = ccSendMoneyEl.querySelector('.receiverCurrencyDrop.wu-currency-flag i')
    const currencyReceiver = ISO_CODES_COUNTRIES_CURRENCIES[receiverCountry]
    if(currencyReceiver) {
      receiverCurrencyEL && receiverCurrencyEL.setAttribute('data-default-receiver-currency-name', currencyReceiver)
      receiverCurrencyEL && receiverCurrencyEL.setAttribute('data-default-receiver-country', receiverCountry)
      receiverFlag && receiverFlag.classList.add(receiverCountry.toLowerCase())
    }
  }
}

(() => {
  try {
      showCCSendMoneyConfigure({})
  } catch(e) {
    // Error handled silently for security
  }
})()